import { connect } from 'react-redux';

import { ISetPassword } from '@models';

import { IApplicationState } from '@store';
import { setPassword } from '@store/actions';

import SetPassword, {
  ISetPasswordStateProps,
  ISetPasswordDispatchProps,
} from '../components/login/SetPassword';

interface IStateToProps
  extends Pick<
    IApplicationState,
    'authentication' | 'setPassword' | 'projectPicker'
  > {}

const mapStateToProps = ({
  authentication,
  setPassword,
  projectPicker,
}: IStateToProps): ISetPasswordStateProps => ({
  error: authentication.error || setPassword.error,
  status: setPassword.status,
  projectPicker: projectPicker,
});

const mapDispatchToProps = (dispatch: any): ISetPasswordDispatchProps => ({
  onSetPassword: (setPasswordParams: ISetPassword) =>
    dispatch(setPassword(setPasswordParams)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SetPassword);
